import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Box } from '@mui/system'
import { useDispatch, useSelector } from 'react-redux'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import BtnWithDropDownList from '../../../../components/Buttons/BtnWithDropDownList'
import UseTranslation from '../../../../hooks/UseTranslation'
import AppRoutes from '../../../../services/AppRoutes'
import CreationUsersBatchModal from '../CreationUsersBatchModal'
import { getBulkCreateUsersIsValid, getBulkCreateUsersProcessIsValid } from '../../../../redux/features/users/customerAdmin/customerAdminThunk'
import { customerAdminSelectUsers } from '../../../../redux/features/users/customerAdmin/customerAdminSlice'
import HoverTooltip from '../../../../components/PageHelpers/HoverTooltip';
import { ReactComponent as People } from '../../../../images/people.svg'
import { ReactComponent as BatchStatus } from '../../../../images/BatchStatus.svg'
import CreationUsersEmptyBatchModal from './CreationUsersEmptyBatchModal'

const DropDownBatchButton = () => {
  const [creationUsersBatchModalState, setCreationUsersBatchModalState] = useState(false)
  const [creationUsersEmptyBatchModalState, setCreationUsersEmptyBatchModalState] = useState(false)
  const history = useHistory()
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const users = useSelector(customerAdminSelectUsers)

  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const handleNavigation = () => {
    history.push(`${baseUri}${AppRoutes.adduser}`)
  }

  useEffect(() => {
    dispatch(getBulkCreateUsersIsValid())
    dispatch(getBulkCreateUsersProcessIsValid())
  }, [])

  const handelUsersBatchCreation = () => {
    if (!users.bulkCreateUsersIsValid) return;

    if (users.allNonRegisterUsersCount === 0) {
      setCreationUsersEmptyBatchModalState(true)
    } else {
      setCreationUsersBatchModalState(true)
    }
  }

  return (
    <Box>
      <BtnWithDropDownList
        title={t?.['Add Customer User']}
        onClick={handleNavigation}
        customStyle={styles.btnWithDropDownList}
      >
        {
         users.bulkCreateUsersProcessIsValid &&
         <>
        <Box
          sx={[styles.sideButton, !users.bulkCreateUsersIsValid && styles.notValid]}
          onClick={handelUsersBatchCreation}
          disabled={true}
        >
          <People />
          {t?.['Users Batch Creation']}
          {!users.bulkCreateUsersIsValid &&
            <HoverTooltip
              title={`${t?.["Sorry you can't create batch action now as there is a batch creation running in the background"]}`}
            >
              <InfoRoundedIcon />
            </HoverTooltip>

          }
        </Box>
        <Box
          sx={styles.sideButton}
          onClick={() => history.push(`${baseUri}${AppRoutes.usersBatchActionsStatus}`)}
        >
          <BatchStatus />
          {t?.['Batch Actions Status']}
        </Box>
        </>

        }

      </BtnWithDropDownList>
      <CreationUsersBatchModal
        modalState={creationUsersBatchModalState}
        setModalState={setCreationUsersBatchModalState}
      />
      <CreationUsersEmptyBatchModal
      modalState={creationUsersEmptyBatchModalState}
      setModalState={setCreationUsersEmptyBatchModalState}
      />
    </Box>
  )
}
const styles = {
  btnWithDropDownList: {
    minHeight: '40px',
    mx: { xs: '10px', sm: '0px' },
  },
  sideButton: {
    display: 'flex',
    width: '90%',
    alignItems: 'flex-end',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: '10px',
    margin: '0px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
    gap: '10px',
    fontFamily: 'Avenir, Roboto, monospace',
    '& svg:first-of-type': {
      display: { xs: 'flex', sm: 'none' },
      filter: 'brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)',
      width: '25px',
      height: '25px',
    },
  },
  notValid: {
    color: 'gray',
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },

}
export default DropDownBatchButton
